import { Component, Inject, Optional, PLATFORM_ID } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { isPlatformBrowser } from '@angular/common';
import * as langConfig from 'src/assets/languageConfig/languageConfig.json';
import { AppComponent } from '../app.component';
import { MatTabsModule } from '@angular/material/tabs';
import {
  ButtonModule,
  IconModule,
  StructuredListModule,
  TilesModule,
} from 'carbon-components-angular';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
@Component({
  selector: 'app-mat-dialog',
  templateUrl: './mat-dialog.component.html',
  styleUrls: ['./mat-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatTabsModule,
    TilesModule,
    ButtonModule,
    StructuredListModule,
    IconModule,
    MatExpansionModule,
    MatIconModule,
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
})
export class MatDialogComponent {
  type: string = '';
  serviceJob: string = '';
  checkpoint: string = '';
  context: string = '';
  condition: string = '';
  price: string = '';
  customerName = '';
  selectedIndex: number = 0;
  jobsCount: string = '';
  content: string = '';
  cost:number | undefined;
  finding:string='';
;
  languageConfiguration: any = langConfig;
  constructor(
    private dialogRef: MatDialogRef<MatDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: AppComponent,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    dialogRef.disableClose = true;
    this.type = data.type;
    this.customerName = data.customerName;
    this.serviceJob = data.serviceJob;
    this.checkpoint = data.checkpoint;
    this.finding=data.finding;
    this.context = data.context;
    this.jobsCount = data.jobs;
    this.condition = data.condition;
    this.cost=data.cost
    if (data.content) {
      this.content = data.content.split('***');
    }
  }

  onSwipe(action: string) {
    if (this.content) {
      if (action === 'left') {
        this.selectedIndex =
          this.selectedIndex < this.content.length
            ? this.selectedIndex + 1
            : this.content.length - 1;
      } else {
        this.selectedIndex =
          this.selectedIndex === 0 ? 0 : this.selectedIndex - 1;
      }
    } else {
      if (action === 'left') {
        this.selectedIndex = 1;
      } else {
        this.selectedIndex = 0;
      }
    }
  }

  changeLanguage(lang: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.translate.changeLanguage(lang);
      this.dialogRef.close();
    }
  }
}
